import { useRef } from "react";
import { Link } from "react-router-dom";
import { ChevronLeft, ChevronRight } from "lucide-react";
import { useStore } from "../../lib/store";
import { ProductCard } from "../site/ProductCard";
import { SectionTitle } from "../site/Reveal";

const TRENDING = ["rose-plaid-shacket", "gingham-getaway-tote", "bloom-flare-jeans", "luxe-lock-crossbody", "toasted-teddy-jacket", "dream-team-cap-set", "cloud-wash-pullover", "check-mate-tote"];

export const Trending = () => {
  const { byId } = useStore();
  const ref = useRef(null);
  const items = TRENDING.map((id) => byId[id]).filter(Boolean);
  const scroll = (dir) => ref.current?.scrollBy({ left: dir * ref.current.clientWidth * 0.8, behavior: "smooth" });
  if (!items.length) return null;
  return (
    <section data-testid="trending-section" className="bg-white py-20 sm:py-28">
      <div className="mx-auto max-w-7xl px-4 sm:px-8">
        <SectionTitle script="Trending Now" eyebrow="Handpicked this week" testId="trending-heading" />
        <div className="mt-10 flex items-center justify-between">
          <Link to="/shop" data-testid="trending-view-all" className="eyebrow text-magenta underline-offset-8 hover:underline">View all</Link>
          <div className="flex gap-2">
            <button aria-label="Previous" data-testid="trending-prev" onClick={() => scroll(-1)} className="grid h-11 w-11 place-items-center rounded-full border border-plum/20 transition-colors hover:bg-plum hover:text-cream"><ChevronLeft className="h-5 w-5" /></button>
            <button aria-label="Next" data-testid="trending-next" onClick={() => scroll(1)} className="grid h-11 w-11 place-items-center rounded-full border border-plum/20 transition-colors hover:bg-plum hover:text-cream"><ChevronRight className="h-5 w-5" /></button>
          </div>
        </div>
      </div>
      <div ref={ref} data-testid="trending-carousel" className="no-scrollbar mt-8 flex snap-x snap-mandatory gap-5 overflow-x-auto px-4 sm:px-8 scroll-px-4 sm:scroll-px-8 lg:px-[max(2rem,calc((100vw_-_80rem)/2_+_2rem))] lg:scroll-px-[max(2rem,calc((100vw_-_80rem)/2_+_2rem))] pb-4">
        {items.map((p, i) => (
          <div key={p.id} className="w-[72vw] shrink-0 snap-start sm:w-[300px]">
            <ProductCard product={p} index={i} />
          </div>
        ))}
      </div>
    </section>
  );
};
